import { orgGoalsIcon } from 'areas/settings/components/settings-layout/constants/SettingsIcons';
import { SidebarNavItem } from '../../../types/SidebarNavItem';
import {
  copilotIcon,
  calendarIcon,
  cogIcon,
  cultureIcon,
  dashboardIcon,
  dataScienceIcon,
  glossaryIcon,
  outcomesIcon,
  recommendationIcon,
  TeamIcon,
  MemberIcon,
} from '../Icons';

import { PORTAL_ROUTES, convertRouteToNavData } from '@/routing/routeConfig';

// Icon mapping for routes
const routeIconMap: Record<string, any> = {
  dashboard: dashboardIcon,
  'culture-hub/bio': TeamIcon,
  'culture-hub/analytics': dashboardIcon,
  'culture-hub/pillars': cultureIcon,
  'culture-hub/interventions': recommendationIcon,
  'culture-hub/team-projects': recommendationIcon,
  analytics: cultureIcon, // Note: using cultureIcon for analytics (existing behavior)
  outcomes: outcomesIcon,
  'org-goals': orgGoalsIcon,
  leaderboard: TeamIcon,
  foundations: dataScienceIcon,
  copilot: copilotIcon,
  'team-management': MemberIcon,
  teams: TeamIcon,
  assessments: calendarIcon,
  'pulse-surveys': calendarIcon,
  'team-projects': recommendationIcon,
  metrics: dataScienceIcon,
  glossary: glossaryIcon,
  'knowledge-base': glossaryIcon,
  summary: outcomesIcon,
};

/**
 * Generate NavData from shared route configuration
 * This ensures consistency between routing permissions and navigation display
 */
function generateNavDataFromRoutes(): SidebarNavItem[] {
  const navItems: SidebarNavItem[] = [];

  // Process each route that should appear in navigation
  Object.values(PORTAL_ROUTES).forEach(route => {
    if (!route.showInNav) return;

    const navItem = convertRouteToNavData(route);

    // Add icon if available
    if (routeIconMap[route.path]) {
      navItem.svg = routeIconMap[route.path];
    }

    navItems.push(navItem);
  });

  // Add admin settings (not in PORTAL_ROUTES as it's a settings route)
  navItems.push({
    id: 'settings',
    link: '/settings/admin/organization',
    title: 'Admin Tools',
    fr: 'Paramètres',
    svg: cogIcon,
    regular_member: false,
    team_admin: false,
    org_admin: false,
    director: false,
    superuser: true,
    staff: true,
    section_title: 'Administration',
  });

  return navItems;
}

export const NavData = generateNavDataFromRoutes();

export default NavData;
